import * as actions from '../actions/overviewTab';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import sampleCombine from "xstream/extra/sampleCombine";
import {isAragUser} from "../helpers/functions";

export function requestOverviewTabTagsDescription(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_OVERVIEW_TAB_TAGS_DESCRIPTION);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/Applications/OverviewTagsMessage',
            category: 'requestOverviewTabTagsDescription',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('requestOverviewTabTagsDescription')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getOverviewTabTagsDescriptionSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestOverviewTabTagsDescriptionFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestOverviewTabTagsDescription')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getOverviewTabTagsDescriptionFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function getApplicationOverview(sources) {
	const query$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_APPLICATION_OVERVIEW);

	const request$ = query$
		.map(action => ({
			url: BASE_URL + 'api/Applications/Overview/'+action.payload,
			category: 'getApplicationOverview',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('getApplicationOverview')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetApplicationOverview(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveFailedResponseApplicationOverview(sources) {
    let httpResponse$ = sources.HTTP
        .select('getApplicationOverview')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetApplicationOverview(response));

    return {
        ACTION: httpResponse$
    };
}

export function postOverviewPolicyForm(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_POST_OVERVIEW_POLICY_FORM)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Overview',
			category: 'postOverviewPolicyForm',
			method: 'POST',
			send: action.payload,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('postOverviewPolicyForm')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receivePostOverviewPolicyFrom(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function getApplicatiovOverviewAfterPost(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_POST_OVERVIEW_POLICY_FORM)
        .map(action => ({
            url: BASE_URL + 'api/Applications/Overview/' + action.payload.applicationId ,
            category: 'getApplicationOverview',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP    
        .select('getApplicationOverview')
        .map((response) => 
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetApplicationOverview(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function getApplicationReadByAragAfterPost(sources) {
    const state$ = sources.STATE;
	const userRoles$ = state$.map(state => state.user.loggedInUser.roles);
    const applicationIdArray$ = state$.map(state => state.newApplication.selectedApplication.id);

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_GET_APPLICATION_OVERVIEW)
        .compose(sampleCombine(userRoles$))
        .filter(([response, userRoles]) => isAragUser(userRoles))
        .compose(sampleCombine(applicationIdArray$)) // Get the selected application id because can't guarantee action.payload contains it
        .map(([action, applicationId]) => ({
            url: BASE_URL + 'api/Applications/' +  applicationId  + '/ReadByArag' ,
            category: 'getApplicationReadByAragAfterPost',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getApplicationReadByAragAfterPost')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetApplicationReadByArag(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveBadRequestPostOverviewPolicyForm(sources) {
	let httpResponse$ = sources.HTTP
		.select('postOverviewPolicyForm')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestPostOverviewPolicyForm(response.response));

	return {
		ACTION: httpResponse$
	};
}